// extracted by mini-css-extract-plugin
module.exports = {"segment":"XlRjL1PS7U9KsDJsI2wH","empty":"T1GHDwhGDa0OgacT1Xvk"};